import { render, staticRenderFns } from "./JxxChart.vue?vue&type=template&id=667457e6&scoped=true"
import script from "./JxxChart.vue?vue&type=script&lang=js"
export * from "./JxxChart.vue?vue&type=script&lang=js"
import style0 from "./JxxChart.vue?vue&type=style&index=0&id=667457e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667457e6",
  null
  
)

export default component.exports